import React from 'react'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import { useClientsDetails } from './hooks/useClientsDetails'
import { INFOCARD_DETAILS, getClientsDetails, SAME_DATE_INFO } from './constants'
import { functionalitiesHelper } from '../../../../utils/functionalitiesHelper'
import { ReactComponent as SearchIcon } from '../../../../assets/icons/search-left.svg'
import { ReactComponent as BenefitsIcon } from '../../../../assets/icons/donate.svg'
import { ReactComponent as PawIcon } from '../../../../assets/icons/paw-outline.svg'
import { ReactComponent as SpentAmountIcon } from '../../../../assets/icons/money-bag-outline.svg'
import { ReactComponent as ServicesIcon } from '../../../../assets/icons/services-outline.svg'
import BackButton from '../../../../components/BackButton'
import ExpandableCard from '../../../../components/Card/ExpandableCard'
import Alert from '../../../../components/Form/Alert'
import DateHeader from '../components/DateHeader'
import * as S from './styles'
import Card from '../../../../components/Card'
import SideMenuTemplate from '../../templates/SideMenu'

const ClientsDetails = () => {
  const { getDates } = functionalitiesHelper
  const { search } = useLocation()
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const { date, sameDate } = queryString.parse(search, { parseBooleans: true })
  const { monthAndYear, day, fullDate } = getDates(date)
  const clientsDetails = useClientsDetails(professional.id, fullDate, sameDate)
  const loading = !clientsDetails
  const header = {
    title: monthAndYear,
    subtitle: `Informações ${sameDate ? 'deste mês ' : ''} até o dia ${day}`,
    loading
  }
  const clientsDetailsCards = clientsDetails ? getClientsDetails(clientsDetails) : []

  return (
    <SideMenuTemplate>
      <BackButton backPage='/vets/dashboard/services' paramData={`?date=${date}&sameDate=${sameDate}`} text='Detalhes sobre os clientes' />
      <S.Container>
        <DateHeader {...header} />
        <ExpandableCard {...INFOCARD_DETAILS}>
          <hr />
          <Alert show>
            Trazemos informações apenas de clientes com CPF ou e-mail cadastrado. São dados essenciais para identificação deles e seus pets.
          </Alert>
          <S.InfoCard>
            <S.CardTitle>
              <SearchIcon />
              <h1>
                Conheça seus clientes
              </h1>
            </S.CardTitle>
            Saiba mais detalhes sobre o perfil, os serviços, a receita e a frequência de cada um.
          </S.InfoCard>
          <hr />
          <S.InfoCard marginBottom>
            <S.CardTitle>
              <BenefitsIcon />
              <h1>
                Ofereça benefícios
              </h1>
            </S.CardTitle>
            Atenda de forma personalizada e ofereça brindes ou cupons de acordo com a necessidade.
          </S.InfoCard>
        </ExpandableCard>
        <S.ClientsInfo>
          {
            loading
              ? Array(3).fill().map((_, index) => <S.Skeleton key={'skeleton' + index}><Card full loading={loading} skeletonHeight={74} /></S.Skeleton>)
              : clientsDetailsCards.map((detail, index) => {
                return (
                  <ExpandableCard key={'clientInfo-' + index} {...detail.card}>
                    <hr />
                    <Alert show>
                      CPF do cliente: {detail.cpf}
                    </Alert>
                    <S.InfoCard>
                      <S.CardTitle>
                        <PawIcon />
                        <h1>
                          Pets desse cliente
                        </h1>
                      </S.CardTitle>
                      {detail.petNames}
                    </S.InfoCard>
                    <hr />
                    <S.InfoCard>
                      <S.CardTitle>
                        <SpentAmountIcon />
                        <h1>
                          Valor gasto em serviços
                        </h1>
                      </S.CardTitle>
                      Esse cliente gastou <S.DataInfo>{detail.amountSpent} reais</S.DataInfo> em serviços {SAME_DATE_INFO[sameDate]}.
                    </S.InfoCard>
                    <hr />
                    <S.InfoCard>
                      <S.CardTitle>
                        <ServicesIcon />
                        <h1>
                          Serviço mais realizado
                        </h1>
                      </S.CardTitle>
                      <S.DataInfo>{detail.mostScheduledService}</S.DataInfo>
                      {detail.mostScheduledServicesAmount > 1
                        ? ' foram os serviços mais realizados por esse cliente '
                        : ' foi o serviço mais realizado por esse cliente '}
                      {SAME_DATE_INFO[sameDate]}.
                    </S.InfoCard>
                  </ExpandableCard>
                )
              })
          }
        </S.ClientsInfo>
      </S.Container>
    </SideMenuTemplate>
  )
}

export default ClientsDetails
